module.exports = __webpack_public_path__ + "static/media/p1a5.48083033.wav";